import * as React from "react";
import Header from "./Header";
import CloseChatModal from "./CloseChatModal";
import formatTime from "../helpers/formatters";
import ConfigContext from "../context/ConfigContext";
import { EngagementConfiguration } from "../types";
import CloseChatForm from "./CloseChatForm";
import MessengerFlexContainer from "./MessengerFlexContainer";

interface ConfigExtension {
  config: EngagementConfiguration;
}

interface QueueProps {
  position: number;
  timeInQueue: number;
  estimatedWait: string;
  isPopout: boolean;
  onPopout: () => void;
  onCollapse: () => void;
  onClose: () => void;
}

interface QueueState {
  showCloseChatModal: boolean;
}

class Queue extends React.Component<QueueProps & ConfigExtension, QueueState> {
  state = {
    showCloseChatModal: false
  };

  content: HTMLDivElement;

  renderCloseChatModal() {
    if (!this.state.showCloseChatModal) {
      return null;
    }

    return (
      <CloseChatModal
        onClickYes={this.props.onClose}
        onClickNo={() => this.setState({ showCloseChatModal: false })}
      />
    );
  }

  renderTimeInQueue() {
    if (!this.props.config.QueueTimerEnabled) {
      return null;
    }

    return (
      <div className="time" aria-live="off">
        {formatTime(this.props.timeInQueue)}
      </div>
    );
  }

  render() {
    return (
      <MessengerFlexContainer>
        {this.renderCloseChatModal()}
        <Header
          isPopout={this.props.isPopout}
          onClose={() => this.setState({ showCloseChatModal: true })}
          onCollapse={this.props.onCollapse}
          onPopout={this.props.onPopout}
        />
        <div className="velaro-queue-container velaro-scroll">
          <div
            className="velaro-queue-content"
            ref={(el) => (this.content = el)}
          >
            <p className="velaro-queue-header-text">
              {this.props.config.QueueHeaderText}
            </p>
            <p>{this.props.config.QueuePositionText}</p>
            <div className="position">{this.props.position}</div>
            {this.props.config.QueueEstimateEnabled && (
              <>
                <p>{this.props.config.QueueEstimateText}</p>
                <div className="estimated-wait">
                  {this.props.estimatedWait || "0:20"}
                </div>
              </>
            )}
            {this.renderTimeInQueue()}
            <CloseChatForm
              onClose={() => this.setState({ showCloseChatModal: true })}
            />
          </div>
        </div>
      </MessengerFlexContainer>
    );
  }
}

export default (props: QueueProps) => (
  <ConfigContext.Consumer>
    {(config) => <Queue config={config} {...props} />}
  </ConfigContext.Consumer>
);
